import React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const useStyles = makeStyles((theme) => ({
  box: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    borderRight: "1px solid #dcdcdc",
  },
  boxLast: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
  title: {
    display: "block",
    height: 32,
    fontSize: 14,
  },
  value: {
    paddingTop: 24,
    paddingBottom: 8,
    fontSize: 14,
    marginTop: 24,
  },
}));

const CheckInCommon = ({ homeDataCheckIn = {} }) => {
  const classes = useStyles();
  const valueOrDash = (value) => value !== undefined ? value : "-";

  return (
    <Grid container spacing={1}>
      <Grid item sm={12} md={12} lg={6}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={4}>
            <StatBoxSlim title="チェックイン回数" value={valueOrDash(homeDataCheckIn.checkInCount)} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <StatBoxSlim title="チェックイン基数" value={valueOrDash(homeDataCheckIn.checkInCountKisu)} tip="チェックインされたユニークの基数" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <StatBoxSlim title="ユニークユーザー数" value={valueOrDash(homeDataCheckIn.checkInCountUniqueUser)} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={12} md={12} lg={6}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={6} md={4}>
            <div className={classes.box}>
              <Typography variant="caption" className={classes.title}>最多基</Typography>
              <Typography variant="caption" className={classes.value}>{valueOrDash(homeDataCheckIn.checkInMost)}</Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className={classes.boxLast}>
              <Typography variant="caption" className={classes.title}>最多ユーザー</Typography>
              <Typography variant="caption" className={classes.value}>{valueOrDash(homeDataCheckIn.checkInMostUser)}</Typography>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  homeDataCheckIn: state.pictreeCommon.homeDataCheckIn,
});

export default connect(mapStateToProps)(CheckInCommon);
